import { defaultTo } from 'lodash';
import type { IAuction } from '../../../../../repositories/billing-tariffs/entities/PublishTerms/Auction';
import { ERestrictionType, IAuctionBet } from '../../../../../reducers/v2';

export const mapAuctionBet = (auction: IAuction | undefined): IAuctionBet => {
  return {
    minBet: defaultTo(auction?.auctionInfo?.minimalBet, 0),
    maxBet: defaultTo(auction?.auctionInfo?.maximalBet, 0),
    value: defaultTo(auction?.auctionInfo?.overServiceBet, 0),
    restrictionType: auction?.strategyInfo?.isEnabled ? ERestrictionType.DeniedByStrategy : undefined,
    step: 10,
    nextBets: [],
    previousBets: [],
    available: Boolean(auction?.isAvailable),
    token: defaultTo(auction?.period?.token, ''),
  };
};
